module.exports = __webpack_public_path__ + "img/zj.f362a2d2.png";